import React, { useEffect } from 'react'
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx'
import SweetAlert from '@components/Feedback/SweetAlert/Index.jsx';
import PageWrapper from '@components/UI/PageWrapper/Index';

const NomeForm = "Tarefas"

const Tarefas = () => {

  useEffect(() => {
    SweetAlert.warningDevMode(
      "Aviso",
      "Esta tela está em desenvolvimento. Algumas funcionalidades podem não estar disponíveis no momento."
    );
  }, []);

  return (
    <PageWrapper>
      <div className="row">
        <BreadcrumbComp Param1="Home" Param2={"Planejamento"} Param3={NomeForm} />
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-6  d-flex align-items-center">
                  <h2 className="mb-0">{NomeForm}</h2>
                </div>
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <div className="col-6 mt-2">
                  <form>

                    {/*  em desenvolvimento */}

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}

export default Tarefas